import React from 'react';
import { Outlet } from 'react-router-dom';

import { useGetDashboardOperationsQuery } from '@/api/v1';
import { ApplicationDialog } from '@/components/organisms/ApplicationDialog';
import {
  DepositFlowAction,
  depositFlowFinished,
  depositFlowReducer,
  DepositFlowState,
  initialState,
  transactionFlowChanged,
} from '@/Screens/Dashboard/Flows/DepositFlow/reducer';
import { AsAnyActionArg } from '@/utility/reducers';

export const DepositFlow: React.FC = (): React.ReactElement => {
  const { data: flows = [] } = useGetDashboardOperationsQuery('DEPOSIT');
  const reducer = React.useReducer<DepositFlowState, AsAnyActionArg<DepositFlowAction>>(
    depositFlowReducer,
    initialState,
  );

  const [, dispatch] = reducer;

  React.useEffect(() => {
    if (flows.length > 0) {
      dispatch(transactionFlowChanged(flows[0]));

      return (): void => {
        dispatch(depositFlowFinished());
      };
    }
  }, [dispatch, flows]);

  return (
    <ApplicationDialog>
      <Outlet context={reducer} />
    </ApplicationDialog>
  );
};
